import { FunctionComponent } from 'react';
import { FullPageLoader } from '@montel/montelpro-shared-components';
import { AuthStatus } from '@montel/montelpro-shared-components/providers';
import { useAuth } from '@montel/montelpro-auth';

export interface PrivateRouteProps {
	children: any;
}

const PrivateRoute: FunctionComponent<PrivateRouteProps> = ({ children }) => {
	const { authStatus } = useAuth();

	if (authStatus === AuthStatus.SUCCESS) {
		return children;
	}

	return <FullPageLoader />;
};

export default PrivateRoute;
